import React from 'react';
import PropTypes from 'prop-types';
import { IconDevicePhoneFill, IconDeviceDesktopFill } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import { Button, ButtonText } from '@saucelabs/ds-button';
import { Box } from '@saucelabs/sl-component-grid';

import { SubscriptionUsageTile, SubscriptionUsageTileMode } from '../SummaryTile';
import { ROUTE_PARENT_SECTION } from '../../constants';
import { Subscription } from '../../records/Subscription';

export const UsageSubscriptionCancelForm = ({ displayModal, subscription }) => (
  <Box className="pl-3 pr-3 pb-3 text-gray-900">
    <Typography
      className="mb-2"
      disableSpacing
      variant="heading-3"
    >
      Your current plan:
    </Typography>
    <SubscriptionUsageTile
      key={subscription.id}
      mode={SubscriptionUsageTileMode.CANCEL_SUBSCRIPTIONS}
      subscription={subscription}
    />
    <div className="flex justify-center">
      <div className="flex flex-col w-3/5">
        <Typography
          className="text-center mt-3 mb-2"
          disableSpacing
          variant="heading-3"
        >
          Canceling you plan today means:
        </Typography>

        <div className="flex justify-center mb-2 text-gray-500">
          <IconDevicePhoneFill className="mr-2 fill-current" />
          <IconDeviceDesktopFill className="fill-current" />
        </div>

        <Typography
          className="text-center"
          disableSpacing
          variant="body"
        >
          {'You will not be able to use Automated and Live Testing to find defects in your '}
          {'desktop/mobile browsers and apps after '}
          <strong>{subscription.displayNextBillDate()}</strong>
          {'.'}
        </Typography>

        <ul className="mt-2 mb-3 list-inside text-center text-sm leading-7">
          <li>
            Your remaining credits will expire.
          </li>
          <li>
            Your account will be read-only.
          </li>
          <li>
            And, starting today, your credits will not be refilled.
          </li>
        </ul>

      </div>
    </div>

    <div className="flex flex-row justify-end">
      <ButtonText
        to={`/${ROUTE_PARENT_SECTION}`}
      >
        Keep my Subscription
      </ButtonText>
      <Button
        className="ml-2"
        color="danger"
        disabled={false}
        onPress={() => displayModal([subscription.id])}
      >
        Unsubscribe Now
      </Button>
    </div>
  </Box>
);

UsageSubscriptionCancelForm.propTypes = {
  displayModal: PropTypes.func.isRequired,
  subscription: PropTypes.instanceOf(Subscription).isRequired,
};
